import React, { Component, useState } from "react";
import { withTranslation } from "react-i18next";
import PostService from "../../../api/PostService";
import i18n from "../../../i18n";
import * as APPCONFIG from "../../../config/app-config.js";
import AuthService from "../../../session/AuthService_old";

import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      base64String: "",
      images: [],
    };
  }

  componentDidMount() {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }

  render() {

    console.log("this.props.announcementData", this.props.announcementData);
    return (
      <div
        className={`cardWrapper ${
          this.props.announcementData?.length > 1 ? "announcement-res-wrap" : ""
        }`}
      >
        <SliderComponent
          announcementData={this.props.announcementData}
          openAnnoucmentScreen={this.callScreen}
        />

      </div>


    );
  }
  callScreen = (id) => {
    this.props.openAnnouncement(id);
  };
  getBase64String(postFile) {
    let getBase64String = {
      resourceString: postFile,
    };

    PostService.getBase64String(getBase64String)
      .then((response) => {
        var value = response.data.data.base64String;
        var base64String = "";

        base64String = `data:image;base64,${value}`;

        this.setState({ base64String: base64String });
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

const SliderComponent = ({ announcementData, openAnnoucmentScreen }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,

  };
  const [slideWidth, setSlideWidth] = useState(0);
  const handleImageLoad = (event) => {
    const img = event.target;
    const ratio = img.naturalWidth / img.naturalHeight;
    setSlideWidth(img.offsetHeight * ratio);
  };
  return (
    <div>
      <Slider {...settings}>
        {announcementData &&
          announcementData.map((announcement, index) => (
            <div
              style={{
                width: slideWidth,
                margin: "0 auto",
                position: "relative",
              }}
              key={index}
              onClick={() => openAnnoucmentScreen(announcement.id)}
            >
              <img
                src={`${APPCONFIG.API_URL}auth/image/${announcement.file}`}
                onLoad={handleImageLoad}

                alt="announcement"
                style={{ display: "block", width: "100%" }}
              />
              <div
                style={{ width: slideWidth }}
                className="home-announcement-wrapper"
              >
                <h5>{announcement.title} </h5>


              </div>
            </div>
          ))}
      </Slider>
    </div>
  );
};



export default withTranslation()(Announcement);
